// @flow
import React from 'react';
import SnackbarContent from '@material-ui/core/SnackbarContent';
import InfoIcon from '@material-ui/icons/Info';
import CloseIcon from '@material-ui/icons/Close';
import IconButton from '@material-ui/core/IconButton';
import { isAcme } from 'isAcme';
import type { MCRuleMessage } from 'data/mcRules/mcRulesTypes';
import { makeStyles } from '@material-ui/core/styles';
import { useDispatch } from 'react-redux'
import { showMCPDialog } from 'components/Dialogs/MCPDialog/mcpDialogActions';
import * as mcRulesActions from 'data/mcRules/mcRulesActions';

const useStyles = makeStyles((theme) => ({
  content: {
    backgroundColor: theme.palette.primary.main,
  },
  icon: {
    marginRight: 16,
  },
}));

type Props = {
  message: MCRuleMessage,
  onClose: () => void,
}

const MCToastSnackbarContent = (props: Props) => {
  const { onClose, message, ...other } = props;
  const classes = useStyles();
  const dispatch = useDispatch();

  return (
    <SnackbarContent
      className={classes.content}
      aria-describedby="mc-toast-snackbar"
      onClick={() => {
        dispatch(showMCPDialog(message.id));
        if (onClose) {
          onClose();
        }
      }}
      message={
        <span id="mc-toast-snackbar">
          <InfoIcon className={classes.icon}/>
          {`Message from ${isAcme ? 'Simplifi' : 'Quicken'}`}
        </span>
      }
      action={[
        <IconButton
          key="close"
          aria-label="close"
          color="inherit"
          onClick={(event) => {
            dispatch(mcRulesActions.mcMessagesTrack({
              id: message.id,
              isRemindMeLater: message.canUserDismiss ? true : undefined,
              reDisplayCount: message.reDisplayCount,
              ruleContext: message.ruleContext,
            }));
            event.stopPropagation();
            if (onClose) {
              onClose();
            }
          }}
        >
          <CloseIcon/>
        </IconButton>,
      ]}
      {...other}
    />
  );
};

export default MCToastSnackbarContent;
